/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LDAPServerReference
 */
export interface LDAPServerReference {
    /**
     * 
     * @type {number}
     * @memberof LDAPServerReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerReference
     */
    readonly name?: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerReference
     */
    readonly winbindSeparator?: string;
    /**
     * 
     * @type {string}
     * @memberof LDAPServerReference
     */
    readonly ntDomain?: string;
}

export function LDAPServerReferenceFromJSON(json: any): LDAPServerReference {
    return LDAPServerReferenceFromJSONTyped(json, false);
}

export function LDAPServerReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LDAPServerReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'winbindSeparator': !exists(json, 'winbind_separator') ? undefined : json['winbind_separator'],
        'ntDomain': !exists(json, 'nt_domain') ? undefined : json['nt_domain'],
    };
}

export function LDAPServerReferenceToJSON(value?: LDAPServerReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


